export enum Endpoints {
    ACTIVITY = 'activity',
    ACTIVITY_TYPES = 'activity-types',
    ASSET = 'asset',
    BACKGROUND_URL = 'setting/background-url',
    CARD = 'card',
    CARD_LOGIN_ALLOWED = 'card-login',
    CARD_UPDATE = 'card-update',
    INVENTORY_UPDATE = 'inventory-update',
    LOCATION = 'location',
    LOG_IN = 'login',
    LOG_IN_NFC = 'login-nfc',
    LOG_OUT = 'logout',
    LOGO_URL = 'setting/logo-url',
    OPTIONS = 'options',
    PLACE_ORDER = 'place-order',
    REFRESH_TOKEN = 'refresh-token',
    REQUEST_ACTIVITY = 'request-activity',
    SEARCH = 'search',
    USER_STATUS_HEART_BEAT = 'heart-beat',
}
